$(function () {
  if ($("#tabs").length > 0) {
    $("#tabs").tabs();
  }
});
$(document).ready(function () {
  $(".browse_logo_slider__1").slick({
    dots: false,
    arrows: true,
    infinite: true,
    centerMode: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    centerPadding: "0",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: true,
          centerPadding: "10%",
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });
  $(".cross_img").on("click", function () {
    $(".announcement-bar").hide();
  });
});

$(document).ready(function () {
  $(".press-images--list").slick({
    dots: false,
    infinite: true,
    speed: 2000,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: false,
          draggable: true,
          touchMove: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
          draggable: true,
          touchMove: true,
          infinite: true,
          centerMode: true,
          centerPadding: "100px",
          useCSS: false,
          speed: 2000,
          autoplaySpeed: 500,
        },
      },
      {
        breakpoint: 526,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          draggable: true,
          touchMove: true,
          infinite: true,
          centerMode: true,
          centerPadding: "100px",
          useCSS: false,
          speed: 2000,
          autoplaySpeed: 500,
        },
      },
      {
        breakpoint: 0,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          draggable: true,
          touchMove: true,
          infinite: true,
          centerMode: true,
          centerPadding: "100px",
          useCSS: false,
        },
      },
    ],
    nextArrow:
      '<button class="slick-next" aria-label="Next slide"><svg class="svg svg-slick-right sv-right-arrow" aria-hidden="true" width="24" height="24" role="img"><use href="#sv-right-arrow" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#sv-right-arrow"></use></svg></button>',
    prevArrow:
      '<button class="slick-prev" aria-label="Previous slide"><svg class="svg svg-slick-left sv-right-arrow" width="24" height="24" aria-hidden="true" role="img"><use href="#sv-right-arrow" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#sv-right-arrow"></use></svg></button>',
  });
});

// let payment_shadow_root = document.querySelector('shopify-payment-terms').shadowRoot;
// if (payment_shadow_root) {
//   console.log(payment_shadow_root);
//   var style = document.createElement('style')
//   style.innerHTML = '#shopify-installments.font-system { font-family: GT Pressura rg; }#shopify-installments-content{display:block;}'
//   payment_shadow_root.appendChild( style )
// }
